<template>
  <div class="popup-form signed-application-popup">
    <div class="content-form-popup">
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt="Zavrieť">
        </div>
        <div class="blackcolor pop-800">Podpísaná žiadosť</div>
      </div>

      <div class="signed-application-popup__body">
        <div class="signed-application-popup__logo-wrap">
          <img
            v-if="payload.application.bank && payload.application.bank.logo_square"
            :src="payload.application.bank.logo_square"
            class="signed-application-popup__logo"
            alt=""
          >
        </div>
        <div class="signed-application-popup__copy">
          <div class="signed-application-popup__eyebrow">Dokončenie podpisu</div>
          <h2 class="signed-application-popup__question">Chcete nahrať aj podpísanú žiadosť?</h2>
          <p class="signed-application-popup__description">
            Vyberte, či chcete iba zmeniť stav, alebo spolu s tým uložiť podpísaný
            dokument do cloudu klienta.
          </p>
        </div>
      </div>

      <div class="signed-application-popup__actions">
        <button
          type="button"
          class="signed-application-popup__secondary"
          :disabled="saving"
          @click="markWithoutScan"
        >
          <span class="signed-application-popup__choice-icon">✓</span>
          <span class="signed-application-popup__choice-copy">
            <strong>{{ saving ? "Ukladám…" : "Nie, iba označiť" }}</strong>
            <small>Bez nahratia dokumentu</small>
          </span>
        </button>
        <button
          type="button"
          class="signed-application-popup__primary"
          :disabled="saving || !payload.applicationCloud"
          @click="openSignedUpload"
        >
          <span class="signed-application-popup__choice-icon signed-application-popup__upload-icon">↑</span>
          <span class="signed-application-popup__choice-copy">
            <strong>Áno, nahrať sken</strong>
            <small>PDF alebo fotografie</small>
          </span>
        </button>
      </div>

      <p v-if="!payload.applicationCloud" class="clientError signed-application-popup__error">
        Cloud žiadosti sa ešte nenačítal. Žiadosť môžete označiť bez skenu alebo modal otvoriť znova.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignedApplicationPopUp",
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    saving: false,
  }),
  methods: {
    closePopup() {
      if (this.saving) return;
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    async markWithoutScan() {
      if (this.saving) return;
      this.saving = true;
      try {
        await this.$store.dispatch("mortgageDetailState/setMortgageApplicationStage", {
          id: this.payload.application.id,
          newStage: "podpisana",
        });
        this.$store.commit("appState/setSuccessMessage", {
          text: "Žiadosť bola označená ako podpísaná.",
          type: "success",
        });
        this.$store.commit("popupManagerState/popItemFromPopupOrder");
      } catch (error) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Stav žiadosti sa nepodarilo zmeniť. Skúste to prosím znova.",
          type: "error",
        });
      } finally {
        this.saving = false;
      }
    },
    openSignedUpload() {
      if (this.saving || !this.payload.applicationCloud) return;
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        extra: {
          force: true,
          accept: ".pdf,.png,.jpg,.jpeg",
          applicationId: this.payload.application.id,
          applicationDocumentType: "podpisana_ziadost",
        },
        type: 2,
        payload: this.payload.applicationCloud,
        component: "DocumentCloudPopUp",
        rules: ["priority"],
      });
    },
  },
};
</script>

<style scoped lang="scss">
.signed-application-popup {
  width: min(620px, 92vw) !important;
  background: var(--app-bg-neutral);
  color: var(--app-text);
}

.signed-application-popup .content-form-popup {
  min-height: 0;
  padding: 28px 30px 34px;
}

.signed-application-popup .header-text {
  padding-bottom: 22px;
  border-bottom: 1px solid var(--app-border);
}

.signed-application-popup .header-text .blackcolor {
  color: var(--app-text) !important;
}

.signed-application-popup__body {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-top: 30px;
}

.signed-application-popup__logo-wrap {
  display: grid;
  width: 70px;
  height: 70px;
  flex: 0 0 70px;
  place-items: center;
  border: 1px solid var(--app-border);
  border-radius: 18px;
  background: var(--app-surface);
  box-shadow: var(--app-shadow);
}

.signed-application-popup__logo {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.signed-application-popup__copy {
  min-width: 0;
}

.signed-application-popup__eyebrow {
  margin-bottom: 5px;
  color: var(--app-primary);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.signed-application-popup__question {
  margin: 0;
  color: var(--app-text) !important;
  font-size: 21px;
  font-weight: 800;
  line-height: 1.3;
}

.signed-application-popup__description {
  margin: 9px 0 0;
  color: var(--app-text-muted);
  font-size: 14px;
  line-height: 1.6;
}

.signed-application-popup__actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 30px;
}

.signed-application-popup__secondary,
.signed-application-popup__primary {
  display: flex;
  min-height: 78px;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  font: inherit;
  text-align: left;
  transition: transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  appearance: none;
}

.signed-application-popup__secondary {
  background: var(--app-surface);
  color: var(--app-text);
  cursor: pointer;
}

.signed-application-popup__primary {
  border-color: transparent;
  background: linear-gradient(135deg, var(--app-primary), #4b9bed);
  color: #fff;
  box-shadow: 0 12px 28px rgba(45, 125, 210, 0.24);
  cursor: pointer;
}

.signed-application-popup__secondary:hover,
.signed-application-popup__primary:hover {
  transform: translateY(-1px);
}

.signed-application-popup__secondary:hover {
  border-color: var(--app-primary);
}

.signed-application-popup__choice-icon {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  place-items: center;
  border-radius: 10px;
  background: var(--app-primary-soft);
  color: var(--app-primary);
  font-size: 19px;
  font-weight: 900;
}

.signed-application-popup__primary .signed-application-popup__choice-icon {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.signed-application-popup__upload-icon {
  font-size: 23px;
  line-height: 1;
}

.signed-application-popup__choice-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.signed-application-popup__choice-copy strong {
  color: inherit;
  font-size: 14px;
}

.signed-application-popup__choice-copy small {
  color: var(--app-text-muted);
  font-size: 12px;
  font-weight: 500;
}

.signed-application-popup__primary .signed-application-popup__choice-copy small {
  color: rgba(255, 255, 255, 0.76);
}

.signed-application-popup__actions button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
  transform: none;
}

.signed-application-popup__error {
  margin-top: 14px;
}

@media screen and (max-width: 560px) {
  .signed-application-popup .content-form-popup {
    padding: 22px 20px 28px;
  }

  .signed-application-popup__body {
    align-items: flex-start;
  }

  .signed-application-popup__actions {
    grid-template-columns: 1fr;
  }
}
</style>
